module.exports = __webpack_public_path__ + "img/Media_Exit_0419.2c4e6575.png";